import React from 'react';

const Ideal = () => {
  return (
    <svg width="34" height="24" viewBox="0 0 34 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="34" height="24" rx="4" fill="white" />
      <rect
        x="0.25"
        y="0.25"
        width="33.5"
        height="23.5"
        rx="3.75"
        stroke="black"
        strokeOpacity="0.15"
        strokeWidth="0.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.24144 4.95605H17.3321C22.83 4.95605 24.9427 8.049 24.9427 11.9585C24.9427 16.635 21.9897 18.9857 17.3321 18.9857H9.24144V4.95605ZM10.0096 5.79734V18.1939H17.3321C21.7496 18.1939 24.1504 16.0659 24.1504 11.9832C24.1504 7.77682 21.5575 5.79734 17.3321 5.79734H10.0096ZM12.1704 12.2059C12.9792 12.2059 13.6349 11.5301 13.6349 10.6965C13.6349 9.86295 12.9792 9.18719 12.1704 9.18719C11.3616 9.18719 10.7059 9.86295 10.7059 10.6965C10.7059 11.5301 11.3616 12.2059 12.1704 12.2059ZM10.9941 12.8493H13.3469V17.1546H10.9941V12.8493Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.4855 9.31079H22.1578V11.3893H23.1421C22.878 7.60349 19.973 6.76221 17.3322 6.76221H14.5232V9.31079H14.9313C15.6996 9.31079 16.1558 9.83041 16.1558 10.6964C16.1558 11.5625 15.6996 12.0821 14.9554 12.0821H14.5232V17.1545H17.3322C21.6296 17.1545 23.0941 15.1008 23.1661 12.0821H21.4855V9.31079ZM18.2445 11.3893V12.0821H16.5639V9.3108H18.1964V10.0036H17.2361V10.3253H18.1484V11.0181H17.2601V11.3893H18.2445ZM18.5325 12.0821L19.3488 9.3108H20.3091L21.1254 12.0821H20.4291L20.2851 11.5625H19.3968L19.2527 12.0821H18.5325ZM19.5964 10.8449H19.5889V10.8696L19.5964 10.8449ZM19.5964 10.8449H20.069L19.853 10.0778H19.829L19.5964 10.8449ZM14.5232 11.3893V10.0036H14.9313C15.1954 10.0036 15.4835 10.0778 15.4835 10.6964C15.4835 11.315 15.2194 11.3893 14.9313 11.3893H14.5232Z"
        fill="#D50072"
      />
    </svg>
  );
};

export default Ideal;
